import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './App.css';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Story from './components/Story';
import Details from './components/Details';
import RSVP from './components/RSVP';
import RSVPResults from './components/RSVPResults';
import Registry from './components/Registry';
import QA from './components/QA';
import Afterparty from './components/Afterparty';

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Ld9MVQsAAAAAGK3umMgOo55FUqoL4m2Slw-9i6I">
      <div className="App">
        <Router>
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/story" element={<Story />} />
              <Route path="/details" element={<Details />} />
              <Route path="/rsvp" element={
                <main>
                  <div className="page-header">
                    <p className="page-header__eyebrow">RSVP</p>
                    <h1 className="page-header__title">RSVPs Closed</h1>
                    <div className="page-header__rule page-rule">
                      <div className="rule-line rule-line--short"></div>
                      <div className="rule-diamond"></div>
                      <div className="rule-line rule-line--short"></div>
                    </div>
                  </div>
                  <section className="rsvp-section">
                    <div className="rsvp-container">
                      <div className="rsvp-search-card" style={{ textAlign: 'center' }}>
                        <p className="rsvp-search-card__intro">
                          Sorry! We are no longer accepting RSVPs. If you have any questions please reach out!
                        </p>
                      </div>
                    </div>
                  </section>
                </main>
              } />
              <Route path="/rsvp-results" element={<RSVPResults />} />
              <Route path="/rsvp-admin" element={<RSVP />} />
              <Route path="/registry" element={<Registry />} />
              <Route path="/qa" element={<QA />} />
              <Route path="/afterparty" element={<Afterparty />} />
            </Routes>
          </main>
        <footer className="footer">
          <div className="container">
            <p>Ashley &amp; A.J. • 2026 &nbsp;·&nbsp; <a href="/rsvp-results">Admin Login</a></p>
          </div>
        </footer>
      </Router>
    </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;